import type { UIInventoryItem, UIItemComparisons, UIPartyCharacter } from '@sorrem-client/types';
import { toEquipment } from '@sorrem-client/ui/shared/inventory-item';
import { getStoredLoadout, resolveGearComparisons } from '@sorrem/shared';
import { useMemo } from 'react';

const NONE: UIItemComparisons = {};

/** How the carried and stored equipment compares with what the character wears (#293, #341), judged as readiness judges gear. */
export function resolveCharacterHomeItemComparisons(character: UIPartyCharacter): UIItemComparisons {
    const wearer = {
        attributes: character.attributes,
        skills: character.skills,
        equipped: getStoredLoadout(character),
        veilAttunementSpent: character.veilAttunementSpent,
    };
    const items = [...character.carriedItems, ...character.storedItems]
        .map((item: UIInventoryItem | undefined) => (item === undefined || item.equipmentType === undefined ? undefined : toEquipment(item)));
    return resolveGearComparisons(wearer, items);
}

/** `resolveCharacterHomeItemComparisons` for the character shown, with its pending moves; none while none is loaded. */
export function useCharacterHomeItemComparisons(character: UIPartyCharacter | null): UIItemComparisons {
    return useMemo(() => (character === null ? NONE : resolveCharacterHomeItemComparisons(character)), [character]);
}
